export const posTop = (element) => element.getBoundingClientRect().top
export const posTopTotal = (element) =>
  element.getBoundingClientRect().top + window.scrollY
